module.exports = __webpack_public_path__ + "static/media/login.d6556f4e.png";